import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import JoditEditor from "jodit-react";
import { toast } from "react-toastify"
import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import { TagsInput } from "react-tag-input-component";
import { FcOk, FcHighPriority, FcFile } from "react-icons/fc";
import { BsFiletypeXlsx } from "react-icons/bs";
import { IoClose } from "react-icons/io5";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import { audioDefaultURL } from "../../../components/CommonApis/CommonAudioApis";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import { navigateChecker } from "../../../components/navigateChecker";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import useCompressImageConfig from "../../../components/CommonApis/Compressimageapi";
import usePpvGlobalImageConfig from "../../../components/CommonApis/ppv_global_change";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { IconDownload } from "../../../Assets/MyIcons";
import AdminCustomRadio from "../../../components/CommonComponents/AdminCustomRadio";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminCustomURLCopy from "../../../components/CommonComponents/AdminCustomURLCopy";
import AdminGalleryModal from "../../../components/CommonComponents/AdminGalleryModal";
import AdminCustomArea from "../../../components/CommonComponents/AdminCustomArea";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import { slugGenerator } from "../../../components/CommonMethod/CommonMethods";
import { connect } from "react-redux";
import { IoMdInformationCircle } from "react-icons/io";
import AdminAIModal from "../../../components/CommonComponents/AdminAImodal";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from '../../../CustomFields/saveCustomFieldsStrict';
import ContentClassification from "../../Site/Settings/Site_Setting/ContentClassification";
import { MdAddCircle } from "react-icons/md";

function Editnewaudio({ storageSetting, onlyPermission, siteTheme, languageCodeData }) {
  const headers = getItemToken('access_token')
  const { compressResolutionFormat } = useCompressImageConfig();
  const { handleFileChangeProvider, fetchRequest, imageValidationAPI } = useMyContext()
  const imageValidationApi = imageValidationAPI()
  const { allCurrencylistfromappi, globalPpvStatusActive } = usePpvGlobalImageConfig();


  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation()

  const baseURL = process.env.REACT_APP_Baseurl
  const labelSource = 'add-audio'
  const createApi = `${baseURL}/admin/audio/create`
  const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`
  const uploadFileApi = `${baseURL}/admin/library/upload?upload_type=audio&clone_to=audio`
  const moveApi = `${baseURL}/admin/audio/move`
  const uploadURLApi = `${baseURL}/admin/Audio_URL`
  const uploadLiveApi = `${baseURL}/admin/LiveAudioURL`
  const updatePPV = `${baseURL}/admin/audio/PayPerViewPrice/StoreUpdate`
  const updateAudio = `${baseURL}/admin/audio/update`
  const storeAudio = `${baseURL}/admin/audio/store`
  const seoUpdate = `${baseURL}/admin/audio/SEO`
  const assingAPI = `${baseURL}/admin/audio/assignto`
  const generateAISuggestionApi = `${baseURL}/admin/ai-prompt-response`
  const [modalTarget, setModalTarget] = useState(null);
  const [defaultPrompt, setDefaultPrompt] = useState("");
  const [showModal, setShowModal] = useState(false);

  const editAudioRegex = /^\/edit-new-audio\/\d+$/
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 1895 + 2 }, (_, index) => ({ name: 1895 + index, value: 1895 + index }));


  const [formData, setFormData] = useState({
    state: "formData",
    selected_categories: [],
    status: 0,
    year: new Date().getFullYear(),
    google_product_id_ppvs_id: null,
    content_classification: "",
    is_ads: 0,
    slider_image: "",
  })
  const [imagerequiredValidation, setImagerequiredValidation] = useState(null)
  const [editAudioStatus, setEditAudioStatus] = useState(false)
  const [defaultEditOption, setDefaultEditOption] = useState()
  const [defaultOption, setDefaultOption] = useState({
    state: "defaultOption",
    artistsOption: [],
    categoryOption: [],
    languageOption: [],
    blockCountryOption: [],
    availableCountryOption: [],
    writerOption: [],
    musicianOption: [],
    ageOption: [],
    albumOption: [],
    accessOption: [],
    iosOption: [],
    lyricsOption: [],
    globalOption: [],
    googleProductIdPPV: [],
    contentClassificationOption: [],
  })

  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [formDataError, setFormDataError] = useState({})
  const [getSuccessLyrics, setSuccessLyrics] = useState(null);
  const [getDangerLyrics, setDangerLyrics] = useState(null);
  const [getLyrics, setLyrics] = useState(null);
  const [coverImageFile, setCoverImageFile] = useState(null);
  const [playerImageFile, setPlayerImageFile] = useState(null);
  const [tvImageFile, setTvImageFile] = useState(null);
  const [sliderImageFile, setSliderImageFile] = useState(null);
  const [pricemodel, setPriceModel] = useState('');
  const [loading, setLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [step, setStep] = useState(1)
  const [currentType, setCurrentType] = useState("")
  const [editData, setEditData] = useState()
  const [currentId, setCurrentId] = useState({
    mp3LiveURLResponse: { loading: false },
    mp3URLResponse: { loading: false }
  })
  const [getGeofencingAvailableCountries, setGetGeoFencingAvailableCountries] = useState(null);
  const [getGeofencing, setGetGeoFencing] = useState(null);
  const [convertPrice, setConvertPrice] = useState({
    source_type: 5,
    source_id: "",
    PPVType: "",
    PriceType: "",
    ActualPrice: "",
    IOSPrice: "",
    convertedPriceRates: []
  })
  const [galleryModal, setGalleryModal] = useState(false)
  const [selectedIds, setSelectedIds] = useState([]);
  const [contentClassificationModal, setContentClassificationModal] = useState(false);
  const [customFieldValues, setCustomFieldValues] = useState({});

  const combinedRef = useRef({
    title: null,
    slug: null,
    description: null,
    details: null,
    rating: null,
    age_restrict: null,
    image: null,
    player_image: null,
    tv_image: null,
    slider_image: null,
    content_classification: null
  });

  useEffect(() => {
    const fetchImageValidation = async () => {
      const ImageValidationresponse = await fetchRequest({
        method: "GET",
        url: imageValidationApi,
        params: {},
        data: {},
      });
      setImagerequiredValidation(ImageValidationresponse?.Compress_image);
    };
    fetchImageValidation();
  }, []);

  const assignDefault = (value, defaultValue = 0) => value ? value : defaultValue;
  const multiSelectLabel = (array, valueKey, labelKey) => {
    return Array.isArray(array) ? array?.map((item) => ({
      value: item[valueKey],
      label: item[labelKey]
    })) : [];
  };

  // ########################## API SECTION ######################

  const fetchCreateData = async () => {
    try {
      const response = await axios.get(`${createApi}`, { headers: headers });
      const result = response?.data;
      const defaultoptionslist = {
        artistsOption: multiSelectLabel(result.artists, 'id', 'artist_name'),
        categoryOption: result.audio_categories,
        languageOption: multiSelectLabel(result.languages, 'id', 'name'),
        blockCountryOption: multiSelectLabel(result.Block_Country, 'id', 'country_name'),
        availableCountryOption: multiSelectLabel(result.Available_country, 'id', 'country_name'),
        writerOption: multiSelectLabel(result.SongWriter, 'id', 'artist_name'),
        musicianOption: multiSelectLabel(result.Musician, 'id', 'artist_name'),
        ageOption: result.Age_Restrict,
        albumOption: result.audio_albums,
        accessOption: result.user_access,
        iosOption: result?.InappPurchase,
        lyricsOption: response?.data?.sample_audio_lyrics ? response?.data?.sample_audio_lyrics : '',
        globalOption: result.ppv_global_price ? result.ppv_global_price : '',
        audioTypeOption: result?.audio_type,
        defaultCurrency: result?.DefaultCurrency?.[0],
        googleProductIdPPV: result?.googleProductIdPPV || [],
        contentClassificationOption: multiSelectLabel(result?.AllClassification, 'title', 'title'),
      }

      if (!defaultoptionslist.googleProductIdPPV || defaultoptionslist.googleProductIdPPV.length === 0) {
        try {
          const createResponse = await axios.get(`${createApi}`, { headers: headers });
          if (createResponse?.data?.googleProductIdPPV?.length) {
            defaultoptionslist.googleProductIdPPV = createResponse.data.googleProductIdPPV;
          }
        } catch (error) {
          console.error("Error fetching fallback googleProductIdPPV:", error);
        }
      }

      setDefaultOption(defaultoptionslist);
      setCurrentType(result?.audio_type[0]?.audio_type)
      setLoading(false)
    } catch (error) {
      console.error(error);
    }
  };

  const labelFetch = async () => {
    try {
      setLoading(true)
      const response = await axios.get(`${labelApi}`, { headers: headers });
      const result = response?.data?.label_management
      setLabelDisplay(result)
      setLoading(false)
    }
    catch (err) {
      setLoading(false)
      toast.error(err?.response?.data?.message)

    }
  }

  const getDefaultCurrencySetting = () => {
    const dc = defaultOption?.defaultCurrency;
    if (Array.isArray(dc)) return dc?.[0] || {};
    return dc || {};
  }

  const handleCovertPrice = async (value) => {
    let formIsValid = true
    if (!formData?.ppv_price) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        ppv_price: "ppv_price cannot be empty.",
      }));
      combinedRef.current['ppv_price'].focus()
      formIsValid = false;
    }
    if (formIsValid) {
      const selectedCountryCode = defaultOption?.defaultCurrency?.code
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_Curreny_generate}/${selectedCountryCode}`);
        const rates = response.data.rates;
        let convertedPrices = allCurrencylistfromappi?.map(item => {
          let country_name = item?.country;
          let Symbol = item?.Symbol || item?.symbol;
          let Code = item?.code;

          const matchingCountry = allCurrencylistfromappi.find(currency => currency.code === item?.code);
          if (matchingCountry) {
            country_name = matchingCountry?.country;
            Symbol = matchingCountry?.Symbol || matchingCountry?.symbol;
          }

          return {
            Code: Code,
            Country: country_name,
            Symbol: Symbol,
            ConvertedPriceRate: (value * (rates[item?.code] || 0)).toFixed(2),
            price: value,
            RateDifference: ((value * (rates[item?.code] || 0)) - value).toFixed(2),
            editPrice: (value * (rates[item?.code] || 0)).toFixed(2),
            ChangedPrice: (value * (rates[item?.code] || 0)).toFixed(2),
            isEditable: true,
          };
        });

        const cfg = getDefaultCurrencySetting();
        if (cfg?.same_country_toggle == 1 && cfg?.same_currency_country) {
            const targetCountryName = cfg?.same_currency_country;
            convertedPrices = convertedPrices.filter(item => 
                String(item.Code).toUpperCase() === String(cfg?.code).toUpperCase() || 
                String(item?.Country).toLowerCase() === String(targetCountryName).toLowerCase()
            );
        } else if (cfg?.enable_secondary_currency == 1 && cfg?.enable_multi_currency != 1) {
            const rawSec = cfg?.secondary_currencies;
            const secCur = (rawSec ? (typeof rawSec === 'string' ? JSON.parse(rawSec) : rawSec) : []) || [];
            const secondaryCodes = secCur.map(c => String(typeof c === 'object' ? (c.short_code || c.value || c.code) : c).toUpperCase());
            convertedPrices = convertedPrices.filter(item => item?.Code && secondaryCodes.includes(String(item.Code).toUpperCase()));
        }

        setConvertPrice(prevState => ({
          ...prevState,
          source_type: 5,
          source_id: currentId?.moveId || id,
          PPVType: formData?.global_ppv,
          PriceType: selectedCountryCode,
          ActualPrice: value,
          IOSPrice: formData?.ios_ppv_price,
          convertedPriceRates: convertedPrices
        }));
      } catch (error) {
        console.error('Error fetching currency conversion rates:', error);
      }
    }
  };

  const handleMoveVideo = async (ids) => {
    setShowOverlay(true);
    try {
      const formDataAdd = {};
      formDataAdd['audio_ids'] = ids

      let response = null
      if (!editAudioStatus) {
        response = await axios.post(`${moveApi}`, formDataAdd, { headers: headers });
      }
      if (editAudioStatus) {
        response = await axios.post(`${assingAPI}?audio_id=${id}&library_id=${ids?.[0]}&updated_type=audio`, {}, { headers: headers });
      }
      const result = response?.data;
      if (result?.status) {
        toast.success(result?.message)
        setSelectedIds([])
        setShowOverlay(false);
        handleToggleGalleryModel()
        navigate("/audio-lists")
      }
      else {
        toast.error(result?.message)
        setShowOverlay(false);

      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
      console.error("error", err)
    }

  }

  const fetchData = async () => {
    setLoading(true)
    try {
      const response = await axios.get(`${audioDefaultURL?.editAudioApi}/${id}`, { headers: headers });
      const result = response?.data;
      const previousFormData = result?.audios;
      const updatedFormData = {
        ...previousFormData,
        selected_artists: multiSelectLabel(previousFormData?.selected_artists, 'artist_id', 'name'),
        selected_categories: previousFormData?.selected_categories?.map(item => item?.category_id),
        selected_Language: multiSelectLabel(previousFormData?.selected_Language, 'language_id', 'name'),
        selected_block_countries: multiSelectLabel(previousFormData?.selected_block_countries, 'country', 'country_name'),
        selected_available_countries: multiSelectLabel(previousFormData?.selected_available_countries, 'id', 'country_name'),
        publisher_musician: multiSelectLabel(previousFormData?.publisher_musician, 'id', 'artist_name'),
        publisher_songwriter: multiSelectLabel(previousFormData?.publisher_songwriter, 'id', 'artist_name'),
        search_tags: previousFormData?.search_tags?.split(",")?.map((tag) => tag.trim()),
        ppv_status: assignDefault(previousFormData.ppv_status),
        album_id: assignDefault(previousFormData.album_id),
        rating: assignDefault(previousFormData.rating),
        active: (previousFormData?.status == null || previousFormData?.status == 0 || previousFormData?.active == 0) ? 0 : 1,
        status: assignDefault(1),
        draft: assignDefault(1),
        featured: assignDefault(previousFormData.featured),
        banner: assignDefault(previousFormData.banner),
        slider_image: previousFormData?.slider_image || "",
        Slider_Thumbnail: previousFormData?.Slider_Thumbnail || "",
        views: assignDefault(previousFormData.views),
        year: previousFormData.year ? previousFormData.year : new Date().getFullYear(),
        age_restrict: assignDefault(previousFormData.age_restrict),
        google_product_id_ppvs_id: previousFormData?.google_product_id_ppvs_id || null,
        is_ads: assignDefault(previousFormData.is_ads),
      };
      setFormData(updatedFormData)
      setGetGeoFencing(result?.getGeofencing);
      setGetGeoFencingAvailableCountries(result?.getGeofencingAvailableCountries);
      setEditData(updatedFormData)

      // Default DropDown List

      const defaultoptionslist = {
        blockCountryOption: multiSelectLabel(result?.Block_Country, 'id', 'country_name'),
        availableCountryOption: multiSelectLabel(result?.Available_country, 'id', 'country_name'),
        artistsOption: multiSelectLabel(result.artists, 'id', 'artist_name'),
        categoryOption: result.audio_categories,
        languageOption: multiSelectLabel(result.languages, 'id', 'name'),
        writerOption: multiSelectLabel(result.SongWriter, 'id', 'artist_name'),
        musicianOption: multiSelectLabel(result.Musician, 'id', 'artist_name'),
        ageOption: result.Age_Restrict,
        albumOption: result.audio_albums,
        accessOption: result.user_access,
        iosOption: result.InappPurchase,
        lyricsOption: response?.data?.sample_audio_lyrics ? response?.data?.sample_audio_lyrics : '',
        globalOption: result.ppv_global_price ? result.ppv_global_price : '',
        defaultCurrency: result?.DefaultCurrency?.[0],
        googleProductIdPPV: result?.googleProductIdPPV || [],
        contentClassificationOption: multiSelectLabel(result?.AllClassification, 'title', 'title'),
      }

      if (!defaultoptionslist.googleProductIdPPV || defaultoptionslist.googleProductIdPPV.length === 0) {
        try {
          const createResponse = await axios.get(`${createApi}`, { headers: headers });
          if (createResponse?.data?.googleProductIdPPV?.length) {
            defaultoptionslist.googleProductIdPPV = createResponse.data.googleProductIdPPV;
          }
        } catch (error) {
          console.error("Error fetching fallback googleProductIdPPV:", error);
        }
      }

      setDefaultOption(defaultoptionslist);
      setDefaultEditOption(defaultoptionslist);

      if (updatedFormData.content_classification) {
        const selectedTitles = updatedFormData.content_classification.split(',').map(item => item.trim());
        const selected = defaultoptionslist.contentClassificationOption.filter(opt => selectedTitles.includes(opt.value));
        setFormData(prev => ({ ...prev, selected_content_classification: selected }));
      }
      setConvertPrice(prevState => {
        return {
          ...prevState,
          source_type: 5,
          source_id: id,
          PPVType: formData?.global_ppv,
          PriceType: result?.DefaultCurrency?.code,
          ActualPrice: formData?.ppv_price,
          IOSPrice: formData?.ios_ppv_price,
          convertedPriceRates: [...result?.ContentPriceRates]
        };
      });
      setLoading(false)
    } catch (error) {
      console.error(error);
    }
  };

  // ########################## API END ##########################

  const handleToggleGalleryModel = (val) => {
    setGalleryModal(prev => !prev)
    if (val == "clear") {
      setSelectedIds([])
    }
  }

  const handleCheckboxChange = (id) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((itemId) => itemId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
  };

  const handlePriceModal = () => {
    setPriceModel((prev) => !prev)
  }

  const handlePriceModalClose = async (status) => {
    const actualStatus = typeof status === 'string' ? status : null;
    if (actualStatus != "done") {
      setFormData((prev) => ({
        ...prev,
        ppv_price: editData?.ppv_price,
        ios_ppv_price: editData?.ios_ppv_price,
        global_ppv: editData?.global_ppv,
        individualPPVTrigger: actualStatus
      }))
    }
    setFormData((prev) => ({
      ...prev,
      individualPPVTrigger: actualStatus
    }))
    await setPriceModel(false)
  }

  const handlePPVPriceStore = async () => {
    setShowOverlay(true);
    try {
      const payload = { ...convertPrice, google_product_id_ppvs_id: formData?.google_product_id_ppvs_id || null };
      const response = await axios.post(`${updatePPV}`, payload, { headers: headers });
      const result = response?.data
      if (result?.status) {
        setShowOverlay(false);
        setPriceModel(false)
        toast.success(result?.message)
      }
      else {
        setShowOverlay(false);
        toast.error(result?.message)
      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
      console.error("error", err)
    }
  }

  const validateImageRatio = (file, expectedRatio, expectedWidth, expectedHeight) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        const width = img.width;
        const height = img.height;
        const ratio = width / height;
        const expectedRatioPrecision = 0.01; // Allow for some minor floating-point precision issues
        const ratioMatch = Math.abs(ratio - expectedRatio) < expectedRatioPrecision;
        const dimensionMatch = (width === expectedWidth && height === expectedHeight);
        if (ratioMatch || dimensionMatch) {
          resolve(true);
        } else {
          resolve(false);
        }
      };
      img.onerror = () => {
        reject(new Error('Error loading image'));
      };
    });
  };

  const handleInput = async (e) => {
    const { name, value, type, checked } = e.target;

    if (name == "skip_start_time" || name == "skip_end_time" || name == "skip_start_session" || name == "recap_start_session" || name == "recap_start_time" || name == "recap_end_time" || name == "url_linktym" || name == "urlEnd_linksec" || name == "free_duration_time" || name == "duration") {
      const formattedInput = value.replace(/\D/g, "");

      const formattedTime = formattedInput
        .replace(/^(\d{2})(\d{2})(\d{2})$/, "$1:$2:$3")
        .substr(0, 8);

      setFormData((prev) => ({
        ...prev,
        [name]: formattedTime,
      }));

      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
      return
    }

    if (type === "radio") {
      if (name == "publish_now" || name == "publish_later") {
        setFormData((prev) => ({
          ...prev,
          publish_type: checked ? name : ''
        }));
      }
      if (name == "audio_type") {
        // if (files?.length === 0) {
        setCurrentType(value)
        // }
      }
      if (name == "global_ppv") {
        setFormData((prev) => ({
          ...prev,
          [name]: value
        }));
      }
    }

    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked ? 1 : 0,
      }));
      if (name == "free_duration_status") {
        if (!checked) {
          setFormDataError((prev) => ({
            ...prev,
            ['free_duration_time']: '',
          }));
        }
      }

      if (name == "global_ppv") {
        if (checked) {
          setFormData((prev) => ({
            ...prev,
            ['ppv_price']: defaultOption?.globalOption,
          }));
          if (globalPpvStatusActive?.PPV_Individual_Contents == 1) {
            await handleCovertPrice(defaultOption?.globalOption)
          }
        }
        else {
          setFormData((prev) => ({
            ...prev,
            ['ppv_price']: editData?.ppv_price,
          }));
          if (globalPpvStatusActive?.PPV_Individual_Contents == 1) {
            await handleCovertPrice(editData?.ppv_price)
          }
        }
      }
    }

    if (type === 'text' || type == "time" || type == "date" || type == "number") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }

    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }

    if (type === "datetime-local") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    if (type === "textarea") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleMultiSelect = (selectedOptions, actionMeta) => {
    setFormData((prev) => ({
      ...prev,
      [actionMeta.name]: selectedOptions
    }))
    setFormDataError((prev) => ({
      ...prev,
      [actionMeta.name]: ""
    }))
  }

  const handleTagsChange = (newTags) => {
    const cleanedTags = (newTags || [])
      .flatMap((tag) => String(tag ?? "").split(","))
      .map((tag) => tag.trim().toLowerCase())
      .filter((tag) => tag !== "")
      .filter((value, index, self) => self.indexOf(value) === index);
    setFormData((prevFormData) => ({
      ...prevFormData,
      search_tags: cleanedTags,
    }));
  };

  const formValidation = async () => {
    let formIsValid = true;
    if (getDangerLyrics) {
      combinedRef.current['lyrics']?.focus()
      formIsValid = false;
    }
    if (!formData?.access) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        access: "Choose the access.",
      }));
      combinedRef.current['access']?.focus()
      formIsValid = false;
    }
    if (formData?.access == "ppv") {
      if (globalPpvStatusActive?.PPV_Individual_Contents == 1 && !formData?.ppv_price && !formData?.ios_ppv_price) {
        setPriceModel(true)
      }
      if (!formData?.ppv_price) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          ppv_price: "PPV price cannot be empty.",
        }));
        combinedRef.current['ppv_price']?.focus()
        formIsValid = false;
      }
      if (!formData?.ios_ppv_price) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          ios_ppv_price: "IOS price cannot be empty.",
        }));
        combinedRef.current['ios_ppv_price']?.focus()
        formIsValid = false;
      }
    }
    if (!formData?.title) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        title: "Title cannot be empty.",
      }));
      combinedRef.current['title']?.focus()
      formIsValid = false;
    } else if (!formData?.slug) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        slug: "Slug cannot be empty.",
      }));
      combinedRef.current['slug']?.focus()
      formIsValid = false;
    }
    if (!formData?.age_restrict) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        age_restrict: "Age cannot be empty.",
      }));
      combinedRef.current['age_restrict']?.focus()
      formIsValid = false;
    }
    if (formData?.selected_categories?.length == 0) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        selected_categories: "Category cannot be empty.",
      }));
      combinedRef.current['selected_categories']?.focus()
      formIsValid = false;
    }

    if (formDataError?.image) {
      combinedRef.current['image']?.focus()
      formIsValid = false;
    }
    if (formDataError?.player_image) {
      combinedRef.current['player_image']?.focus()
      formIsValid = false;
    }
    if (formDataError?.tv) {
      combinedRef.current['tv_image']?.focus()
      formIsValid = false;
    }
    if (formData?.duration?.length < 6) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        duration: "Please enter valid duration HHMMSS",
      }));
      combinedRef.current['duration']?.focus()
      formIsValid = false;
    }
    if (formData?.website_URL) {
      const urlPattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
      if (!urlPattern.test(formData?.website_URL)) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          website_URL: "Please enter a valid URL format (e.g., https://example.com)",
        }));
        combinedRef.current['website_URL']?.focus()
        formIsValid = false;
      }
    }

    if (imagerequiredValidation?.audios === 1) {
      if (((id && (formData?.image_url?.includes('default_vertical_image.webp') || formData?.image_url?.includes('uploads/settings/'))) || (!id && !coverImageFile)) && !coverImageFile) {
        setFormDataError(prev => ({
          ...prev,
          image: "Please provide cover image"
        }));
        combinedRef.current['image']?.focus();
        formIsValid = false;
      }
      if (((id && (formData?.player_image_url?.includes('default_horizontal_image.webp') || formData?.player_image_url?.includes('uploads/settings/'))) || (!id && !playerImageFile)) && !playerImageFile) {
        setFormDataError((prev) => ({
          ...prev,
          "player_image": "Please provide player image"

        }))
        combinedRef.current['player_image']?.focus()
        formIsValid = false;
      }
      if (((id && (formData?.tv_image_url?.includes('default_horizontal_image.webp') || formData?.tv_image_url?.includes('uploads/settings/'))) || (!id && !tvImageFile)) && !tvImageFile) {
        setFormDataError((prev) => ({
          ...prev,
          "tv_image": "Please provide tv image"
        }))
        combinedRef.current['tv_image']?.focus()
        formIsValid = false;
      }
      if (formData?.banner === 1) {
        if (((id && (formData?.Slider_Thumbnail?.includes('default_slider_image.webp') || formData?.Slider_Thumbnail?.includes('uploads/settings/'))) || (!id && !sliderImageFile)) && !sliderImageFile) {
          setFormDataError((prev) => ({
            ...prev,
            "slider_image": "Please provide slider image"
          }))
          combinedRef.current['slider_image']?.focus()
          formIsValid = false;
        }
      }
    }

    // Validate title
    if (!formData?.title || formData?.title.trim().length < 3 || formData?.title.trim().length > 100) {
      toast.error("Title must be between 3 and 100 characters.");
      formIsValid = false;
    }

    // Validate slug
    if (!formData?.slug || formData?.slug.trim().length < 3 || formData?.slug.trim().length > 100) {
      toast.error("Slug must be between 3 and 100 characters.");
      formIsValid = false;
    }

    // You can add more validations for other fields here

    return formIsValid;

  }

  const handleAdd = async () => {
    setShowOverlay(true);
    try {
      const formDataAdd = {};
      for (const key in formData) {
        // 'event_date',
        if (['title', 'slug', 'ppv_status', 'ppv_price', 'type', 'access', 'album_id', 'artists', 'rating', 'details', 'description', 'active', 'status', 'featured', 'banner', 'slider_image', 'duration', 'views', 'year', 'albumname', 'age_restrict', 'ios_ppv_price', 'master_percentage_holding', 'songwriter_percentage_holding', 'content_classification', 'is_ads'].includes(key)) {
          if (key === 'album_id' && formData[key] === '') {
            formDataAdd[key] = null;
          } else {
            formDataAdd[key] = formData[key];
          }
        }
      }
      formDataAdd["artists"] = 1;
      formDataAdd["audio_id"] = currentId?.moveId || id;
      formDataAdd["global_ppv"] = formData?.global_ppv;
      formDataAdd["language_id"] = formData?.selected_Language ? formData?.selected_Language.map(option => option?.value) : [];
      formDataAdd["category_id"] = formData?.selected_categories || [];
      formDataAdd["search_tags"] = Array.isArray(formData?.search_tags) ? formData?.search_tags.join(',') : '';
      formDataAdd["google_product_id_ppvs_id"] = formData?.google_product_id_ppvs_id;
      formDataAdd["content_classification"] = formData?.selected_content_classification?.map((option) => option?.value).join(',');
      formDataAdd["artist_id"] = formData?.selected_artists?.map((option) => option?.value);
      formDataAdd["publisher_musician"] = formData?.publisher_musician?.map((option) => option?.value).join(',');
      formDataAdd["publisher_songwriter"] = formData?.publisher_songwriter?.map((option) => option?.value).join(',');
      formDataAdd["available_countries_id"] = formData?.selected_available_countries ? formData?.selected_available_countries?.map((option) => option?.value).join(',') : "";
      formDataAdd["country"] = formData?.selected_block_countries ? formData?.selected_block_countries?.map((option) => option?.value).join(',') : "";
      formDataAdd["ads_position"] = formData?.selected_available_countries?.map((option) => option?.value).join(',');
      let findApi = formData?.status === 1 ? await axios.patch(`${updateAudio}`, formDataAdd, { headers: headers }) : await axios.post(`${storeAudio}`, formDataAdd, { headers: headers });
      const response = findApi
      const result = response?.data;
      if (result?.status) {
        // save custom field values (strict)
        try {
          const entityId = currentId?.moveId || id;
          await saveCustomFieldsStrict({ baseURL, headers, entityType: 'audio', entityId, values: customFieldValues });
        } catch (e) {
          toast.error(e.message);
          setShowOverlay(false);
          return;
        }
        if (formData?.website_page_title || formData?.website_URL || formData?.Meta_description) {
          await handleSeoUpload()
        }
        if (coverImageFile || playerImageFile || tvImageFile) {
          await handleImageUpload()
        }
        if (getLyrics) {
          await handleLyricsUpload()
        }
        if (formData?.individualPPVTrigger == "done") {
          await handlePPVPriceStore()
        }
        setShowOverlay(false);
        toast.success(result?.message)
        // if (audioCheck) {
        // navigate(`/update-song-writer-percentage-holding/${id || currentId?.moveId}`);
        // } else {
        //   navigate("/audio-lists");
        // }
        setWithOutRefresh(prev => !prev)
      }
      else {
        setShowOverlay(false);
        toast.error(result?.message)
      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
      console.error("error", err)
    }
  }

  const handleSeoUpload = async () => {
    try {
      const formDataAdd = {};
      for (const key in formData) {
        if (['website_page_title', 'Meta_description', 'website_URL'].includes(key)) {
          formDataAdd[key] = formData[key];
        }
      }
      formDataAdd['audio_id'] = currentId?.moveId || id;
      const response = await axios.post(`${seoUpdate}`, formDataAdd, { headers: headers });
      if (!response?.data?.status) {
        toast.error(response?.data?.message)
      }
    } catch (err) {
      console.error(err)
    }
  }

  const handleImageUpload = async () => {
    try {
      const formData = new FormData();
      const imageFields = [];
      formData?.append("id", currentId?.moveId || id);
      formData?.append("modelName", "Audio");
      if (coverImageFile && coverImageFile instanceof File) {
        formData.append("image", coverImageFile);
        imageFields.push("image");
      } else if (coverImageFile) {
        console.warn("Skipping image upload: coverImageFile is not a valid File object", coverImageFile);
      }

      if (playerImageFile && playerImageFile instanceof File) {
        formData.append("player_image", playerImageFile);
        imageFields.push("player_image");
      } else if (playerImageFile) {
        console.warn("Skipping image upload: playerImageFile is not a valid File object", playerImageFile);
      }

      if (tvImageFile && tvImageFile instanceof File) {
        formData.append("tv_image", tvImageFile);
        imageFields.push("tv_image");
      } else if (tvImageFile) {
        console.warn("Skipping image upload: tvImageFile is not a valid File object", tvImageFile);
      }
      if (sliderImageFile && sliderImageFile instanceof File) {
        formData.append("slider_image", sliderImageFile);
        imageFields.push("slider_image");
      } else if (sliderImageFile) {
        console.warn("Skipping image upload: sliderImageFile is not a valid File object", sliderImageFile);
      }

      console.log("Image Upload Payload:", {
        id: currentId?.moveId || id,
        imageFields,
        coverImageFile: coverImageFile instanceof File ? "Valid File" : coverImageFile,
        playerImageFile: playerImageFile instanceof File ? "Valid File" : playerImageFile,
        tvImageFile: tvImageFile instanceof File ? "Valid File" : tvImageFile
      });

      imageFields.forEach((field) => {
        formData.append('imageFields[]', field);
      });

      // Prepare headers for multipart/form-data
      const uploadHeaders = { ...headers };
      delete uploadHeaders['Content-Type']; // Allow browser to set correct boundary

      const response = await axios.post(`${audioDefaultURL?.uploadImageURL}`, formData, { headers: uploadHeaders });
      setCoverImageFile(null)
      setPlayerImageFile(null)
      setTvImageFile(null)
      if (!response?.data?.status) {
        toast.error(response?.data?.message)
      }
    } catch (err) {
      console.error(err)
    }
  }

  const handleLyricsUpload = async () => {
    try {
      const formData = new FormData();
      formData?.append("lyrics", getLyrics);
      formData?.append("audio_id", currentId?.moveId || id);
      console.log("Lyrics Upload Payload:", {
        id: currentId?.moveId || id,
        lyrics: getLyrics instanceof File ? "Valid File" : getLyrics
      });

      const lyricsUploadHeaders = { ...headers };
      delete lyricsUploadHeaders['Content-Type'];

      const response = await axios.post(`${audioDefaultURL?.uploadLyrics}`, formData, { headers: lyricsUploadHeaders });
      if (!response?.data?.status) {
        toast.error(response?.data?.message)
      }
    }
    catch (err) {
      console.error(err)
    }
  }

  const handleLyrics = async (event) => {
    setSuccessLyrics(null);
    setDangerLyrics(null);
    const selectedFile = event.target.files;
    if (selectedFile) {
      const newFile = selectedFile[0];
      setLyrics(newFile);
      try {
        const lyricsDatas = new FormData();
        lyricsDatas.append("lyrics", newFile);
        const lyricsHeaders = { ...headers };
        delete lyricsHeaders['Content-Type'];
        const response = await axios.post(`${audioDefaultURL?.validateLyrics}`, lyricsDatas, { headers: lyricsHeaders });
        let result = response?.data;
        if (result?.status == true) {
          setSuccessLyrics(result?.message);
        } else {
          setSuccessLyrics(null);
          setDangerLyrics(result?.message);
        }
      } catch (err) {
        var errorMessage = err?.response?.data?.message;
        setSuccessLyrics(null);
        setDangerLyrics(errorMessage);
      }
    }
  };

  const handleClearFile = () => {
    setLyrics(null);
    setSuccessLyrics(null);
    setDangerLyrics(null);
  };


  const handlePriceChangeInput = (e, index) => {
    const { value } = e.target;
    setConvertPrice(prevState => {
      const updatedRates = [...prevState.convertedPriceRates];
      updatedRates[index] = {
        ...updatedRates[index],
        ConvertedPriceRate: value
      };
      return {
        ...prevState,
        convertedPriceRates: updatedRates
      };
    });
  };

  const handleNextMethod = (movingId) => {
    // Check the current path to determine where to navigate
    const currentPath = location.pathname

    if (currentPath.startsWith('/details-entry/')) {
      navigate(`/details-entry/${movingId}`)
    } else {
      navigate(`/edit-audio/${movingId}`)
    }
    // setStep(2)
    // setCurrentId(prev => ({
    //   ...prev,
    //   moveId: movingId
    // }))
    // console.log(movingId)
  }

  const handleAddMore = (name) => {
    if (name == "mp3_url") {
      setCurrentId(prev => {
        const clearData = { ...prev }
        clearData.mp3URLResponse = {}
        return clearData
      })
      setFormData(prev => ({
        ...prev,
        mp3_url: ""
      }))
    }
    if (name === "mp3_live_url") {
      setCurrentId(prev => {
        const clearData = { ...prev }
        clearData.mp3LiveURLResponse = {}
        return clearData
      })
      setFormData(prev => ({
        ...prev,
        mp3_live_url: ""
      }))
    }

  }

  // const handleUrlUpload = async (name) => {
  //   const formDataObject = {};
  //   let formIsValid = true
  //   if (name == "mp3_url") {
  //     if (!formData?.mp3_url) {
  //       setFormDataError((prevFormData) => ({
  //         ...prevFormData,
  //         mp3_url: "Mp3 url cannot be empty.",
  //       }));
  //       combinedRef.current['mp3_url'].focus()
  //       formIsValid = false;
  //       return
  //     }
  //     else {
  //       formDataObject["mp3_url"] = formData?.mp3_url.trim()
  //     }
  //   }
  //   if (name == "mp3_live_url") {
  //     if (!formData?.mp3_live_url) {
  //       setFormDataError((prevFormData) => ({
  //         ...prevFormData,
  //         mp3_live_url: "Mp3 live  url cannot be empty.",
  //       }));
  //       combinedRef.current['mp3_live_url'].focus()
  //       formIsValid = false;
  //       return
  //     }
  //     else {
  //       formDataObject["mp3_live_url"] = formData?.mp3_live_url.trim();
  //     }
  //   }

  //   if (formIsValid) {
  //     setCurrentId(prev => {
  //       const updatedState = { ...prev };
  //       if (name === "mp3_url") {
  //         updatedState.mp3URLResponse = { loading: true };
  //       }
  //       if (name === "mp3_live_url") {
  //         updatedState.mp3LiveURLResponse = { loading: true };
  //       }
  //       return updatedState;
  //     });

  //     try {
  //       const response = await axios.post(`${name == "mp3_url" ? id ? `${uploadURLApi}?updated_type=updated&audio_id=${id}` : `${uploadURLApi}?updated_type=created` : id ? `${uploadLiveApi}?updated_type=updated&audio_id=${id}` : `${uploadLiveApi}?updated_type=created`}`, formDataObject, { headers: headers })
  //       const result = response?.data
  //       if (result?.status) {
  //         toast.success(result?.message)
  //         setCurrentId(prev => {
  //           const updatedState = { ...prev };
  //           if (name === "mp3_url") {
  //             updatedState.mp3URLResponse = { ...result, id: result?.id, loading: false };
  //           }
  //           if (name === "mp3_live_url") {
  //             updatedState.mp3LiveURLResponse = { ...result, id: result?.id, loading: false };
  //           }
  //           return updatedState;
  //         });
  //       }
  //       else {
  //         toast.error(result.message)
  //       }
  //     }
  //     catch (error) {
  //       const errorMessage = error?.response?.data?.message;
  //       toast.error(errorMessage)
  //       setCurrentId(prev => {
  //         const updatedState = { ...prev };
  //         if (name === "mp3_url") {
  //           updatedState.mp3URLResponse = { loading: false };
  //         }
  //         if (name === "mp3_live_url") {
  //           updatedState.mp3LiveURLResponse = { loading: false };
  //         }
  //         return updatedState;
  //       });
  //     }
  //   }

  // }

  const handleUrlUpload = async (name) => {
    const formDataObject = {};

    const isValidURL = (url) => {
      try {
        new URL(url);
        return true;
      } catch (_) {
        return false;
      }
    };

    const hasValidFileNameBeforeExtension = (url, allowedExtensions) => {
      const lowerUrl = url.toLowerCase();
      const lastSlashIndex = lowerUrl.lastIndexOf("/");
      const fileName = lowerUrl.slice(lastSlashIndex + 1); // e.g., audio.mp3

      const extensionMatch = allowedExtensions.find(ext => lowerUrl.endsWith(ext));
      if (!extensionMatch) return false;

      return fileName.length > extensionMatch.length; // must be something before .mp3
    };

    if (name === "mp3_url") {
      const audioUrl = formData?.mp3_url?.trim();
      const allowedExtensions = [".mp3", ".wav", ".aac", ".flac", ".aiff"];

      if (!audioUrl) {
        setFormDataError(prev => ({ ...prev, mp3_url: "Audio URL cannot be empty." }));
        combinedRef.current["mp3_url"].focus();
        return;
      }

      if (!isValidURL(audioUrl)) {
        setFormDataError(prev => ({ ...prev, mp3_url: "Invalid URL format." }));
        combinedRef.current["mp3_url"].focus();
        return;
      }

      if (!hasValidFileNameBeforeExtension(audioUrl, allowedExtensions)) {
        setFormDataError(prev => ({
          ...prev,
          mp3_url: "Allowed file types: MP3, WAV, AAC, FLAC, AIFF with valid filename before extension.",
        }));
        combinedRef.current["mp3_url"].focus();
        return;
      }

      formDataObject["mp3_url"] = audioUrl;
    }

    if (name === "mp3_live_url") {
      const liveUrl = formData?.mp3_live_url?.trim();
      const allowedExtensions = [".mp3", ".aac"];

      if (!liveUrl) {
        setFormDataError(prev => ({ ...prev, mp3_live_url: "Live audio URL cannot be empty." }));
        combinedRef.current["mp3_live_url"].focus();
        return;
      }

      if (!isValidURL(liveUrl)) {
        setFormDataError(prev => ({ ...prev, mp3_live_url: "Invalid URL format." }));
        combinedRef.current["mp3_live_url"].focus();
        return;
      }

      if (!hasValidFileNameBeforeExtension(liveUrl, allowedExtensions)) {
        setFormDataError(prev => ({
          ...prev,
          mp3_live_url: "Allowed file types: MP3, AAC with valid filename before extension.",
        }));
        combinedRef.current["mp3_live_url"].focus();
        return;
      }

      formDataObject["mp3_live_url"] = liveUrl;
    }

    // Proceed if valid
    setCurrentId(prev => {
      const updated = { ...prev };
      if (name === "mp3_url") updated.mp3URLResponse = { loading: true };
      if (name === "mp3_live_url") updated.mp3LiveURLResponse = { loading: true };
      return updated;
    });

    try {
      const apiURL =
        name === "mp3_url"
          ? id
            ? `${uploadURLApi}?updated_type=updated&audio_id=${id}`
            : `${uploadURLApi}?updated_type=created`
          : id
            ? `${uploadLiveApi}?updated_type=updated&audio_id=${id}`
            : `${uploadLiveApi}?updated_type=created`;

      const response = await axios.post(apiURL, formDataObject, { headers });

      const result = response?.data;
      if (result?.status) {
        toast.success(result?.message);
        setCurrentId(prev => {
          const updated = { ...prev };
          if (name === "mp3_url") updated.mp3URLResponse = { ...result, id: result.id, loading: false };
          if (name === "mp3_live_url") updated.mp3LiveURLResponse = { ...result, id: result.id, loading: false };
          return updated;
        });
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Upload failed");
      setCurrentId(prev => {
        const updated = { ...prev };
        if (name === "mp3_url") updated.mp3URLResponse = { loading: false };
        if (name === "mp3_live_url") updated.mp3LiveURLResponse = { loading: false };
        return updated;
      });
    }
  };



  const handleStore = async (e) => {
    if (await formValidation()) {
      handleAdd()
    }
    else {
      console.table("validation")
    }

  }

  const handleBlurtitle = () => {
    if (!formData?.slug) {
      generateSlug(formData?.title);
    }
  };

  const generateSlug = async (title) => {
    const slug = await slugGenerator(title)
    setFormData((prev) => ({
      ...prev,
      'slug': slug,
    }));
  };

  const handleInputKeyDowntitle = (event) => {
    if (!formData?.slug) {
      if (event.key === "Enter" || event.key === "Tab") {
        generateSlug(formData?.name);
      }
    }
  };

  const handleFileChange = async (event) => {
    const { files, name, value, accept } = event.target
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    setFormDataError((prev) => ({
      ...prev,
      [name]: "",
    }));


    if (files?.length > 0) {
      const newFile = files[0];


      if (
        (['image', 'player_image', 'tv_image', 'slider_image'].includes(name)) &&
        !allowedTypes.includes(files[0]?.type)
      ) {
        setFormDataError((prev) => ({
          ...prev,
          [name]: "Only JPG, JPEG, and PNG files are allowed.",
        }));

        if (name === 'image') setCoverImageFile(null);
        if (name === 'player_image') setPlayerImageFile(null);
        if (name === 'tv_image') setTvImageFile(null);
        if (name === 'slider_image') setSliderImageFile(null);

        combinedRef.current[name]?.focus();
        return;
      }


      const reader = new FileReader();
      const readFile = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        });
      };
      const fileContent = await readFile(newFile);
      const isValidSizeVertical = await validateImageRatio(newFile, 2 / 3, 1080, 1620);
      const isValidSizeHorizontal = await validateImageRatio(newFile, 16 / 9, 1280, 720);
      const checkSize = compressResolutionFormat?.audios === 1

      if (name == 'image') {
        setCoverImageFile(newFile);
        setFormData((prev) => ({
          ...prev,
          [name]: newFile
        }))
        if (!isValidSizeVertical && checkSize) {
          setFormDataError((prev) => ({
            ...prev,
            [name]: "Image must be in 2:3 Ratio or 1080x1620px.",
          }));
        }
      }

      if (name == 'player_image') {
        setPlayerImageFile(newFile);
        setFormData((prev) => ({
          ...prev,
          [name]: newFile
        }))

        if (!isValidSizeHorizontal && checkSize) {
          setFormDataError((prev) => ({
            ...prev,
            [name]: "Image must be in 16:9 Ratio or 1280x720px.",
          }));
        }
      }
      if (name == 'tv_image') {
        setTvImageFile(newFile);
        setFormData((prev) => ({
          ...prev,
          [name]: newFile
        }))
        if (!isValidSizeHorizontal && checkSize) {
          setFormDataError((prev) => ({
            ...prev,
            [name]: "Image must be in 16:9 Ratio or 1280x720px.",
          }));
        }
      }
      if (name == 'slider_image') {
        const isValidSizeSlider = await validateImageRatio(newFile, 8 / 3, 3840, 1440);
        setSliderImageFile(newFile);
        setFormData((prev) => ({
          ...prev,
          [name]: newFile
        }))
        if (!isValidSizeSlider && checkSize) {
          setFormDataError((prev) => ({
            ...prev,
            [name]: "Image must be 3840x1440px or in 8:3 Ratio",
          }));
        }
      }
    }
  };

  const handleLibraryChange = async (e, name) => {
    const files = e.target.files;
    if (!files?.length) return;

    const allowedTypes = /^audio\/.*/;
    for (let file of files) {
      if (!allowedTypes.test(file.type)) {
        toast.error(`Unsupported file format: ${file.name}`);
        e.target.value = ''; // Clear the file input
        return;
      }
    }

    const { site_storage_limit, site_storage_memory } = storageSetting;

    // Convert storage limit to bytes
    const memoryUnits = {
      MB: 1024 ** 2,
      GB: 1024 ** 3,
      TB: 1024 ** 4
    };

    const unitMultiplier = memoryUnits[site_storage_memory];
    if (!unitMultiplier) {
      alert(`Invalid storage unit: ${site_storage_memory}`);
      return;
    }

    const byteLimit = site_storage_limit * unitMultiplier;

    // Calculate total file size
    const totalSize = Array.from(files).reduce((sum, file) => sum + file.size, 0);

    if (totalSize > byteLimit) {
      alert(`Upload exceeds limit: ${site_storage_limit} ${site_storage_memory}`);
      e.target.value = null; // Reset file input
      return;
    }
    if (name === "audio") {
      handleFileChangeProvider(e, `${uploadFileApi}${editAudioStatus ? `&action_type=updated&video_id=${id}` : '&action_type=created'}`, "audio");
      e.target.value = null;
    }
  }

  const handleClearSelectFile = (value) => {
    if (value == 'image') {
      setCoverImageFile(null)
    }
    if (value == 'tv_image') {
      setTvImageFile(null)
    }
    if (value == 'player_image') {
      setPlayerImageFile(null)
    }
    if (value == 'slider_image') {
      setSliderImageFile(null)
    }
    setFormDataError((prev) => ({
      ...prev,
      [value]: ""
    }))
  }

  useEffect(async () => {
    if (id) {
      await fetchData();
      setStep(2)
      if (editAudioRegex.test(location?.pathname)) {
        setStep(1)
        setEditAudioStatus(true)
        await fetchCreateData()
      }
    }
    else {
      setStep(1)
      await fetchCreateData()
    }
    labelFetch()
  }, [withOutRefresh, location]);

  useEffect(() => {
    if (editAudioRegex.test(location?.pathname)) {
      setEditAudioStatus(true)
    }
    else {
      setEditAudioStatus(false)
    }
  }, [editAudioRegex])

  if (loading) {
    return <Defaultloadinggif />
  }
  const closeModal = () => {
    setShowModal(false);
  };

  const confirmToggle = (suggestedText) => {
    if (suggestedText && typeof suggestedText === 'string' && modalTarget) {
      setFormData(prev => ({ ...prev, [modalTarget]: suggestedText }));
    }
    setShowModal(false);
    setModalTarget(null);
  };

  const handleModal = (target) => {
    setModalTarget(target);
    if (target === "description") {
      setDefaultPrompt(`Give a short description about "${formData?.title || ""}"`);
    } else if (target === "details") {
      setDefaultPrompt(`Expand the content details for "${formData?.title || ""}"`);
    }
    setShowModal(true);
  };

  const generateSuggestion = async (promptText, setSuggestion, setLoading) => {
    const trimmedPrompt = promptText?.trim();
    setLoading(true);
    try {
      const response = await axios.post(
        generateAISuggestionApi,
        { prompt: trimmedPrompt },
        { headers }
      );
      if (response.data?.status) {
        setLoading(false);
        setSuggestion(response.data.response);
      } else {
        alert(response.data.message || "Failed to generate suggestion.");
      }
    } catch (error) {
      if (error.response?.status === 401) {
        alert("Token expired or invalid. Please login again.");
      } else {
        console.error(error);
        alert("Error generating suggestion.");
      }
    }
  };

  function CategoryMultiSelect({ options, value = [], onChange }) {
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
      function handleClickOutside(event) {
        const box = combinedRef.current.category_checkbox;
        if (box && !box.contains(event.target)) {
          setOpen(false);
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const toggle = (id) => {
      if (value.includes(id)) {
        onChange(value.filter(v => v !== id));
      } else {
        onChange([...value, id]);
      }
    };

    return (
      <div ref={(el) => (combinedRef.current.category_checkbox = el)} className="position-relative w-100">
        <div
          className="custom-input-border custom-input theme-text-color cursor-pointer mb-3"
          onClick={(e) => {
            e.stopPropagation();
            setOpen(o => !o);
          }}
        >
          {value.length
            ? `${value.length} categories selected`
            : "Choose categories"}
        </div>

        {open && (
          <div className="position-absolute bg-white border shadow z-50 mt-1 max-h-80 overflow-auto w-100" style={{ zIndex: 50, maxHeight: "320px" }}>
            <TreeCheckbox
              options={options || []}
              selected={value}
              onToggle={toggle}
              level={0}
            />
          </div>
        )}
      </div>
    );
  }

  function TreeCheckbox({ options, selected, onToggle, level }) {
    return (
      <ul className="list-unstyled p-0 m-0">
        {options.map(item => (
          <li key={item.id}>
            <label
              className="custom-input theme-text-color d-flex align-items-center gap-2 py-1 cursor-pointer m-0"
              style={{ paddingLeft: level * 16 }}
            >
              <input
                type="checkbox"
                checked={selected.includes(item.id)}
                onChange={() => onToggle(item.id)}
              />
              {item.name}
            </label>

            {(item.sub_category?.length > 0 || item.sub_categories?.length > 0) && (
              <TreeCheckbox
                options={item.sub_category || item.sub_categories}
                selected={selected}
                onToggle={onToggle}
                level={level + 1}
              />
            )}
          </li>
        ))}
      </ul>
    );
  }

  return (
    <>
      <div className="">

        {galleryModal && <AdminGalleryModal modelClose={galleryModal} closeAction={handleToggleGalleryModel} sourceType={5} saveAction={handleMoveVideo} changeAction={handleCheckboxChange} selectedIds={selectedIds} buttonText={"Select Audio"} />}
        {showOverlay && (<Response_Processing></Response_Processing>)}
        <div class={`modal  packageModel fade ${pricemodel && 'd-block show'}`} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" >
          <div className="modal-dialog modal-large" role="document">
            <div className="modal-content  theme-bg-color ">
              <div className="modal-header theme-border-bottom-secondary">
                <MessageBox text="Price exchange" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                <button type="button" className='bg-transparent' onClick={handlePriceModalClose} ><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
              </div>
              <div className="modal-body">
                {/* <div className="d-flex justify-content-between mb-2 col-8 me-auto">
                  <div className="col-12 col-md-6 pe-2">
                    <MessageSubHeading text={labelDisplay?.[42]?.sub_title} />
                  </div>
                  <div className="col-12 col-md-6 ps-2 text-end">
                    <AdminSwitch name={'global_ppv'} checked={formData?.global_ppv == 1} onChange={handleInput} />
                  </div>
                </div> */}
                <div className="row mx-0 align-items-start mb-3 ">
                  <div className="col-12 col-md-5 ps-0 ">
                    <MessageLabel text={`${formData?.global_ppv == 0 ? labelDisplay?.[45]?.title : labelDisplay?.[43]?.title}  (${defaultOption?.defaultCurrency?.symbol} ${defaultOption?.defaultCurrency?.code}) - ${defaultOption?.defaultCurrency?.country}`} />
                    <AdminCustomInput isReadonly={formData?.global_ppv == 1} type="text" name="ppv_price" value={formData?.ppv_price} onChange={handleInput} placeHolder={"Please enter the ppv price"} ref={(el) => (combinedRef.current.ppv_price = el)} error={formDataError?.ppv_price} />
                  </div>
                  <div className="col-12 col-md-5 ">
                    <MessageLabel text={`${labelDisplay?.[44]?.title}  (${defaultOption?.defaultCurrency?.symbol} ${defaultOption?.defaultCurrency?.code}) - ${defaultOption?.defaultCurrency?.country}`} />
                    <AdminCustomSelect name="ios_ppv_price" value={formData?.ios_ppv_price || 0} onChange={handleInput} ref={(el) => (combinedRef.current.ios_ppv_price = el)} options={defaultOption?.iosOption?.map((item, index) => ({ name: item.plan_price, value: item.id }))} error={formDataError?.ios_ppv_price} defaultOptionName={"Choose an ios price"} />
                  </div>
                  {Array.isArray(defaultOption?.googleProductIdPPV) && defaultOption.googleProductIdPPV.length > 0 && (
                    <div className="col-12 col-md-5 mt-3 ps-0 ">
                      <MessageLabel text="Google Purchase" />
                      <AdminCustomSelect
                        name="google_product_id_ppvs_id"
                        value={formData?.google_product_id_ppvs_id || ''}
                        onChange={(e) => {
                          const planId = e.target.value;
                          setFormData(prev => ({
                            ...prev,
                            google_product_id_ppvs_id: planId ? parseInt(planId) : null,
                          }));
                        }}
                        options={defaultOption.googleProductIdPPV.map(plan => ({
                          name: plan?.product_id || plan?.name || `Product ${plan?.id}`,
                          value: plan?.id,
                        }))}
                        defaultOptionName="Choose Google Purchase"
                      />
                    </div>
                  )}
                  <div className="col-12 col-md-2 pe-0 align-self-center mt-4">
                    <AdminCustomButton className='px-3 py-1 m-0' saveMethod={() => handleCovertPrice(formData?.ppv_price)} saveText='Convert' />
                  </div>
                </div>
                <div className="priceTable rounded-3  ">
                  <table class="table rounded-3  position-relative">
                    <thead className="theme-bg-color-secondary">
                      <tr>
                        <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Country</th>
                        <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Current Price</th>
                        <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Converted Price</th>
                        {/* <th scope="col">Converted IOS Price</th> */}
                        <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Difference</th>
                      </tr>
                    </thead>
                    <tbody>
                      {convertPrice?.convertedPriceRates?.length ? convertPrice?.convertedPriceRates.map((item, index) => (
                        <tr key={index}>
                          <td className="" scope="row">{`${item?.Country} (${item?.Code})`}</td>
                          <td className="">{item.Symbol} {item?.price || item?.ActualPrice}</td>
                          <td className=""> <AdminCustomInput isReadonly={formData?.global_ppv == 1} type="text" name="price" value={item?.ConvertedPriceRate} onChange={(e) => handlePriceChangeInput(e, index)} placeHolder={"Fill the custom price"} noMargin noBorder={formData?.global_ppv == 1} className={`${formData?.global_ppv == 1 && 'border-0'}`} /> </td>
                          <td className="">{item?.RateDifference}</td>
                        </tr>
                      )) :
                        <tr>
                          <td colSpan={4} className="errorred text-center">* Please update the pricing according to the specific market in each currency !.</td>
                        </tr>}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer  border-0">
                <button type="button" className="bg-transparent theme-text-color sliderBtnText px-2" onClick={handlePriceModalClose} ><MessageBox text="Cancel" /> </button>
                <AdminCustomButton className='px-3 py-1 m-0 ' saveMethod={() => handlePriceModalClose("done")} saveText='Done' />
              </div>
            </div>
          </div>
        </div>
        {<AdminBackNavigation path={`${editAudioStatus ? `/edit-audio/${id}` : "/audio-lists"}`} text="Back" />}
        {step == 1 &&
          <React.Fragment>
            <Wrapper>
              <div>
                <MessageHeading text={`${location.pathname.startsWith('/details-entry/') ? "Add Audio" : "Edit Audio"}`} padding border />
                <div className="row m-0 pt-4 justify-content-center">
                  <div className="radio-options text-center  d-flex ">
                    {defaultOption?.audioTypeOption?.map((data, index) => (
                      <div key={index} className={`col-md-3 col-6 mb-2 text-md-center text-start mb-3 `}>
                        <div className="d-flex align-items-center justify-content-center">
                          <AdminCustomRadio id={data?.audio_type?.replaceAll("_", "-")} name="audio_type" value={data?.audio_type} checked={currentType == data?.audio_type} onChange={handleInput} />
                          <MessageLabel text={data?.name} className="ms-1 mb-md-0 mb-0 " />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="px-3 pb-3">
                  {currentType == "mp3_audio_upload" && (
                    <>
                      <div className="customDropWrapper rounded-4 theme-bg-color-secondary">
                        <div className="dropZoneText d-flex align-items-center justify-content-center">
                          <MessageBox text="Drag and drop Audios files here, or Click to select files" classname="theme-text-color" />
                        </div>
                        <input id="audio-file-upload" type="file" accept="audio/*" className="w-100 h-100" multiple onChange={(e) => handleLibraryChange(e, "audio")} />
                      </div>
                      <MessageSubHeading className={"text-center mt-4"} text={`Max Upload Limit (${storageSetting?.site_storage_limit} ${storageSetting?.site_storage_memory})`} />
                      <AdminCustomButton id="audio-choose-from-library" saveMethod={handleToggleGalleryModel} saveText="Choose from library" className="mt-3" />
                    </>
                  )
                  }
                  {currentType == "mp3_url" && (
                    <>
                      <MessageLabel text="Mp3 Url" />
                      <AdminCustomInput id="audio-mp3-url" type="text" name="mp3_url" value={formData?.mp3_url} onChange={handleInput} placeHolder={"Paste the mp3 url"} ref={(el) => (combinedRef.current.mp3_url = el)} error={formDataError?.mp3_url} />
                      {!currentId?.mp3URLResponse?.id && <AdminCustomButton id="audio-submit-mp3-url" loading={currentId?.mp3URLResponse?.loading} saveMethod={() => handleUrlUpload('mp3_url')} saveText="Submit" className="d-block mt-3  ms-auto" />}
                      {currentId?.mp3URLResponse?.id &&
                        <div className="mt-3 d-flex gap-2 ms-auto justify-content-end">
                          <AdminCustomButton id="audio-add-more-mp3-url" saveMethod={() => handleAddMore('mp3_url')} saveText="Add More" className="d-inline-block" />
                          <AdminCustomButton id="audio-next-mp3-url" saveMethod={() => handleNextMethod(currentId?.mp3URLResponse?.id)} saveText="Proceed Next" className="d-inline-block" />
                        </div>}

                    </>)
                  }
                  {currentType == "mp3_live_url" && (
                    <>
                      <MessageLabel text="Mp3 Live URL" />
                      <AdminCustomInput id="audio-mp3-live-url" type="text" name="mp3_live_url" value={formData?.mp3_live_url} onChange={handleInput} placeHolder={"Paste the mp3 live url"} ref={(el) => (combinedRef.current.mp3_live_url = el)} error={formDataError?.mp3_live_url} />
                      {!currentId?.mp3LiveURLResponse?.id && <AdminCustomButton id="audio-mp3-live-url" saveMethod={() => handleUrlUpload('mp3_live_url')} saveText="Submit" className="d-block mt-3  ms-auto" />}
                      {currentId?.mp3LiveURLResponse?.id &&
                        <div className="mt-3 d-flex gap-2 ms-auto justify-content-end">
                          <AdminCustomButton id="audio-add-more-mp3-live-url" saveMethod={() => handleAddMore('mp3_live_url')} saveText="Add More" className="d-inline-block" />
                          <AdminCustomButton id="audio-next-mp3-live-url" saveMethod={() => handleNextMethod(currentId?.mp3LiveURLResponse?.id)} saveText="Proceed Next" className="d-inline-block" />
                        </div>}
                    </>
                  )}
                </div>
              </div>

            </Wrapper>
          </React.Fragment>
        }

        {step == 2 &&
          <React.Fragment>
            <AdminSaveHeader heading={!id ? labelDisplay?.[0]?.title : labelDisplay?.[41]?.title} saveText={labelDisplay?.[40]?.title} saveMethod={handleStore} link={id ? navigateChecker(languageCodeData, siteTheme, `music/track/${formData?.slug}`) : ""} />
            <FormContainer>
              <LeftWrapper>
                <Wrapper>

                  {/* {id && <MessageHeading text={formData?.title} />} */}
                  {id && (
                    <MessageHeading
                      text={
                        formData?.title?.length > 4
                          ? formData?.title.slice(0, 30) + "..."
                          : formData?.title
                      }
                    />
                  )}
                  <MessageLabel text={labelDisplay?.[2]?.title} className="mandatorySimple" />
                  <MessageSubHeading text={labelDisplay?.[2]?.sub_title} />
                  <AdminCustomInput id="audio-title" type="text" name="title" value={formData?.title} onChange={handleInput} placeHolder={"Title"} ref={(el) => (combinedRef.current.title = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.title} />

                  <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
                  <MessageSubHeading text={labelDisplay?.[3]?.sub_title} />
                  <AdminCustomInput id="audio-slug" type="text" name="slug" value={formData?.slug} ref={(el) => (combinedRef.current.slug = el)} onChange={handleInput} placeHolder={"Slug"} error={formDataError?.slug} />

                  {showModal && (<AdminAIModal modalDescription="Suggest AI" modalHeading="Generate Content" modelClose={showModal} sliderClose={closeModal} applySuggestion={confirmToggle} generateSuggestion={generateSuggestion} defaultPrompt={defaultPrompt} />)}
                  <MessageLabel text={labelDisplay?.[4]?.title} enableAI handleAIModal={() => handleModal("description")} />
                  <MessageSubHeading text={labelDisplay?.[4]?.sub_title} />
                  <AdminCustomArea id="audio-description" name="description" value={formData?.description || ""} onChange={handleInput} ref={(el) => (combinedRef.current.description = el)} placeHolder={"description"} rows={5} />

                  <MessageLabel text={labelDisplay?.[5]?.title} enableAI handleAIModal={() => handleModal("details")} />
                  <MessageSubHeading text={labelDisplay?.[5]?.sub_title} />
                  <JoditEditor id="audio-details" className="mb-3" ref={(el) => (combinedRef.current.details = el)} value={formData?.details} onChange={(newContent) => setFormData(prev => ({ ...prev, details: newContent }))} />

                  {contentClassificationModal && (
                    <div className={`modal packageModel fade ${contentClassificationModal && 'd-block show'}`} id="audioContentClassificationModal" tabIndex="-1" role="dialog" aria-labelledby="audioContentClassificationModalLabel" >
                      <div className="modal-dialog modal-large" role="document">
                        <div className="modal-content theme-bg-color ">
                          <div className="modal-header theme-border-bottom-secondary">
                            <MessageBox text="Add Content Classification" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                            <button type="button" className='bg-transparent theme-text-color' onClick={() => setContentClassificationModal(false)} aria-label="Close"><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                          </div>
                          <div className="modal-body">
                            <ContentClassification isModal={true} onSuccess={(newTitle) => {
                              if (newTitle) {
                                setDefaultOption(prev => ({
                                  ...prev,
                                  contentClassificationOption: [...(prev?.contentClassificationOption || []), { value: newTitle, label: newTitle }]
                                }));
                                setFormData(prev => {
                                  const curr = Array.isArray(prev?.selected_content_classification) ? prev.selected_content_classification : [];
                                  return { ...prev, selected_content_classification: [...curr, { value: newTitle, label: newTitle }] };
                                });
                              }
                              setContentClassificationModal(false);
                            }} />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="card p-3 mt-3">
                    {/* <MessageHeading text="Additional Fields" /> */}
                    {/* Custom fields */}
                    <FieldRenderer2
                      pageIdentifier={id ? "audio.edit" : "audio.create"}
                      entityType="audio"
                      entityId={id}
                      text="Additional Fields"
                    />
                    <FieldRenderer
                      pageIdentifier={id ? "audio.edit" : "audio.create"}
                      entityType="audio"
                      entityId={id}
                      onChange={setCustomFieldValues}
                    />
                  </div>

                  <MessageLabel text={labelDisplay?.[7]?.title} />
                  <MessageSubHeading text={labelDisplay?.[7]?.sub_title} />
                  <AdminCustomSelect id="audio-year" name="year" value={formData?.year} onChange={handleInput} ref={(el) => (combinedRef.current.year = el)} options={years} error={formDataError?.year} defaultOptionName="Choose video release year" />

                </Wrapper>


                <Wrapper>
                  <MessageHeading text={labelDisplay?.[8]?.title} />
                  <MessageLabel text={labelDisplay?.[13]?.title} className='mandatorySimple' />
                  <MessageSubHeading text={labelDisplay?.[13]?.sub_title} />
                  <CategoryMultiSelect
                    options={defaultOption?.categoryOption}
                    value={formData.selected_categories || []}
                    onChange={(vals) =>
                      setFormData(p => ({ ...p, selected_categories: vals }))
                    }
                    name={"selected_categories"}
                  />
                  {formDataError?.selected_categories && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.selected_categories}`} classname='errorred d-block' /></div>)}

                  <MessageLabel text={labelDisplay?.[10]?.title} className="mandatorySimple" />
                  <MessageSubHeading text={labelDisplay?.[10]?.sub_title} />
                  <AdminCustomSelect id="audio-age" name="age_restrict" value={formData?.age_restrict} onChange={handleInput} ref={(el) => (combinedRef.current.age_restrict = el)} options={defaultOption?.ageOption?.map((item, index) => ({ name: item?.slug, value: item?.id }))} error={formDataError?.age_restrict} defaultOptionName={"Choose an age"} />

                  <div className="d-flex justify-content-between align-items-start">
                    <div className="pe-2">
                      <MessageLabel text={"Content Classification"} />
                      <MessageSubHeading text={"Select the content classification"} />
                    </div>
                    {/* <button type="button" id="audio-content-classification-add-button" className="vjs-big-play-button rounded" onClick={() => setContentClassificationModal(true)} title="Add Content Classification">
                      <MdAddCircle style={{ width: "20px", height: "20px" }} />
                    </button> */}
                  </div>
                  <Select inputId="audio-content-classification" options={defaultOption?.contentClassificationOption} isMulti name={'selected_content_classification'} onChange={handleMultiSelect} value={formData?.selected_content_classification} className="custom-select-multi custom-placeholder theme-text-color mb-3" />

                  <MessageLabel text={labelDisplay?.[14]?.title} />
                  <MessageSubHeading text={labelDisplay?.[14]?.sub_title} />
                  <Select inputId="audio-language" options={defaultOption?.languageOption} isMulti name={'selected_Language'} ref={(el) => (combinedRef.current.selected_Language = el)} onChange={handleMultiSelect} value={formData?.selected_Language} className={`${formDataError?.selected_Language && 'custom-input-error'} custom-select-multi custom-placeholder theme-text-color mb-3`} />
                  {formDataError?.selected_Language && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.selected_Language}`} classname='errorred  d-block' /></div>)}

                  <MessageLabel text={labelDisplay?.[9]?.title} />
                  <MessageSubHeading text={labelDisplay?.[9]?.sub_title} />
                  <AdminCustomSelect id="audio-rating" name="rating" value={formData?.rating} onChange={handleInput} ref={(el) => (combinedRef.current.rating = el)} options={Array.from({ length: 10 }).map((_, index) => ({ name: index + 1, value: index + 1 }))} error={formDataError?.rating} defaultOptionName={"Choose an rating"} />

                  <MessageLabel text={labelDisplay?.[12]?.title} />
                  <MessageSubHeading text={labelDisplay?.[12]?.sub_title} />
                  <Select inputId="audio-artist" options={defaultOption?.artistsOption} isMulti name={'selected_artists'} onChange={handleMultiSelect} value={formData?.selected_artists} className="custom-select-multi custom-placeholder theme-text-color mb-3" />

                  <MessageLabel text={labelDisplay?.[11]?.title} />
                  <MessageSubHeading text={labelDisplay?.[11]?.sub_title} />
                  <AdminCustomSelect id="audio-album" name="album_id" value={formData?.album_id} onChange={handleInput} ref={(el) => (combinedRef.current.album_id = el)} options={defaultOption?.albumOption?.map((item, index) => ({ name: item?.albumname, value: item?.id }))} error={formDataError?.album_id} defaultOptionName={"Choose an album"} />


                  {/* <MessageLabel text={labelDisplay?.[17]?.title} />
                  <MessageSubHeading text={labelDisplay?.[17]?.sub_title} />
                  <Select options={defaultOption?.musicianOption} isMulti name={"publisher_musician"} onChange={handleMultiSelect} value={formData?.publisher_musician} className="custom-select-multi custom-placeholder theme-text-color mb-3" />

                  <MessageLabel text={labelDisplay?.[18]?.title} />
                  <MessageSubHeading text={labelDisplay?.[18]?.sub_title} />
                  <Select options={defaultOption?.writerOption} isMulti name={"publisher_songwriter"} onChange={handleMultiSelect} value={formData?.publisher_songwriter} className="custom-select-multi custom-placeholder theme-text-color mb-3" />

                  <MessageLabel text={labelDisplay?.[19]?.title} />
                  <MessageSubHeading text={labelDisplay?.[19]?.sub_title} />
                  <AdminCustomInput type="number" name="songwriter_percentage_holding" value={formData?.songwriter_percentage_holding} ref={(el) => (combinedRef.current.songwriter_percentage_holding = el)} onChange={handleInput} placeHolder={"Songwriter Percentage Holding"} error={formDataError?.songwriter_percentage_holding} />

                  {formData?.songwriter_percentage_holding ?
                    formData?.publisher_songwriter_holder.map((item) => {
                      return <div className="d-flex align-items-center gap-3 col-6 justify-content-between">
                        <MessageSubHeading text={item?.artist_name} />
                        <MessageSubHeading text={`${item?.percentage_holding}%`} />
                      </div>
                    }) : ""}

                  <MessageLabel text={labelDisplay?.[20]?.title} />
                  <MessageSubHeading text={labelDisplay?.[20]?.sub_title} />
                  <AdminCustomInput type="number" name="master_percentage_holding" value={formData?.master_percentage_holding} ref={(el) => (combinedRef.current.master_percentage_holding = el)} onChange={handleInput} placeHolder={"Master Percentage Holding"} error={formDataError?.master_percentage_holding} /> */}

                  {/* <MessageLabel text={labelDisplay?.[21]?.title} />
                  <MessageSubHeading text={labelDisplay?.[21]?.sub_title} />
                  <AdminCustomInput type="datetime-local" name="event_date" value={formData?.event_date} onChange={handleInput} placeHolder={"Event Date"} error={formDataError?.event_date} /> */}

                </Wrapper>
                {(getGeofencing === "ON" || getGeofencingAvailableCountries === 1) && (
                  <Wrapper>
                    <MessageHeading text={labelDisplay?.[46]?.title} />
                    {getGeofencing === "ON" && (
                      <>
                        <MessageLabel text={labelDisplay?.[15]?.title} />
                        <MessageSubHeading text={labelDisplay?.[15]?.sub_title} />
                        <Select inputId="audio-available-country" options={defaultOption?.blockCountryOption?.filter((blockedItem) => !formData?.selected_available_countries?.some((availableItem) => availableItem?.value === blockedItem?.value))} isMulti name={"selected_block_countries"} onChange={handleMultiSelect} value={formData?.selected_block_countries} className="custom-select-multi custom-placeholder theme-text-color mb-3" />
                      </>)}
                    {getGeofencingAvailableCountries === 1 && (
                      <>
                        <MessageLabel text={labelDisplay?.[16]?.title} />
                        <MessageSubHeading text={labelDisplay?.[16]?.sub_title} />
                        <Select inputId="audio-blocked-country" options={defaultOption?.availableCountryOption?.filter((blockedItem) => !formData?.selected_block_countries?.some((availableItem) => availableItem?.value === blockedItem?.value))} isMulti name={`selected_available_countries`} onChange={handleMultiSelect} value={formData?.selected_available_countries} className="custom-select-multi custom-placeholder theme-text-color mb-3" />
                      </>)}
                  </Wrapper>
                )}
                <Wrapper>
                  <MessageHeading text={labelDisplay?.[6]?.title} />
                  <MessageLabel text={labelDisplay?.[6]?.title} />
                  <MessageSubHeading text={labelDisplay?.[6]?.sub_title} />
                  <AdminCustomInput id="audio-duration" type="text" maxLength="6" name="duration" value={formData?.duration} ref={(el) => (combinedRef.current.duration = el)} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.duration} />
                </Wrapper>

                <Wrapper>
                  <MessageHeading text={labelDisplay?.[38]?.title} />
                  <MessageLabel text={labelDisplay?.[39]?.title} />
                  <MessageSubHeading text={labelDisplay?.[39]?.sub_title} />
                  <TagsInput id="audio-tags" name="search_tags" value={formData?.search_tags} separators={["Enter", ","]} classNames={{ tag: "custom-search-tag", input: "w-100" }} onChange={handleTagsChange} />
                </Wrapper>

              </LeftWrapper>
              <RightWrapper>
                {id && <Wrapper>
                  <MessageHeading text={`Audio ${formData?.type?.replace(/_/g, " ")}`} />
                  <audio key={formData?.audio_url} src={formData?.audio_url} controls className="w-100">
                    Your browser does not support the audio element.
                  </audio>
                  <AdminCustomURLCopy link={formData?.audio_url} className="copy-board-input" />
                </Wrapper>}

                <Wrapper>
                  <MessageHeading text={labelDisplay?.[22]?.title} />
                  <MessageLabel text={labelDisplay?.[23]?.title} />
                  <div className="d-flex align-items-center justify-content-between gap-2  mb-4">
                    {formData?.lyrics && <Link to={formData?.audio_lyrics} id="audio-lyrics-download" className="theme-text-color opacity-75 shadow rounded-5" download >
                      <div className="d-flex align-items-center gap-3 py-2 px-3 ">
                        <IconDownload styled={{ className: "download-icon" }} />
                        <MessageLabel text="Uploaded Lyrics File" className='mb-sm-0' />
                      </div>
                    </Link>
                    }

                    <Link to={defaultOption?.lyricsOption} id="audio-sample-lyrics-download" className="theme-text-color opacity-75 shadow rounded-5" download >
                      <div className="d-flex align-items-center gap-3 py-2 px-3 ">
                        <IconDownload styled={{ className: "download-icon" }} />
                        <MessageLabel text="Sample Lyrics File" className='mb-sm-0' />
                      </div>
                    </Link>
                  </div>

                  <div className="d-flex flex-wrap justify-content-between gap-2">
                    <div className="col-sm-5 col-md-12 col-lg-5 col-12 position-relative pb-2">
                      <div className="imagedrop theme-border-color mt-1 p-1">
                        <input className="opacity-0 h-100 p-0 m-0 " id="audio-lyrics-upload-zone" type="file" accept=".xlsx" ref={(el) => (combinedRef.current.lyrics = el)} onChange={handleLyrics} key={getLyrics ? getLyrics : "no"} />
                        <label type="button" className="position-absolute  theme-text-color">
                          <BsFiletypeXlsx className=" theme-text-color" />
                        </label>
                      </div>
                    </div>

                    {(getSuccessLyrics || getDangerLyrics) && (
                      <div className="col-sm-5 col-12 col-md-12 col-lg-5">
                        <div className="imagedrop theme-border-color d-flex mt-1 p-1 justify-content-between">
                          <button type="button" className="w-75 h-100 bg-transparent"><FcFile /></button>
                          <button type="button" id="audio-lyrics-upload-zone-clear" className="btn btn-close theme-text-color" onClick={handleClearFile} ></button>
                        </div>
                      </div>
                    )}
                  </div>

                  {getSuccessLyrics && (
                    <p className="fw-bold text-success mt-2 theme-text-color admin-input-description"><FcOk className="me-1" />{getSuccessLyrics}</p>
                  )}

                  {getDangerLyrics && (
                    <p className="fw-bold text-danger mt-2 theme-text-color admin-input-description"><FcHighPriority className="me-1" />{getDangerLyrics} </p>
                  )}
                </Wrapper>

                <Wrapper>
                  <MessageHeading text={labelDisplay?.[24]?.title} />
                  <MessageLabel text={labelDisplay?.[25]?.title} className={imagerequiredValidation?.audios === 1 ? "mandatorySimple" : ""} />
                  <MessageSubHeading text={labelDisplay?.[25]?.sub_title} />
                  <AdminImageUploadZone
                    onChange={handleFileChange}
                    selectedFile={coverImageFile}
                    uploadedImage={formData?.image_url}
                    onDelete={handleClearSelectFile}
                    ref={(el) => (combinedRef.current.image = el)}
                    name="image"
                    orientationSlug="portrait"
                    id={id}
                    idAttribute="audio-image"
                    error={formDataError?.image}
                  />

                  <MessageLabel text={labelDisplay?.[26]?.title} className={imagerequiredValidation?.audios === 1 ? "mandatorySimple" : ""} />
                  <MessageSubHeading text={labelDisplay?.[26]?.sub_title} />
                  <AdminImageUploadZone
                    onChange={handleFileChange}
                    selectedFile={playerImageFile}
                    uploadedImage={formData?.player_image_url}
                    onDelete={handleClearSelectFile}
                    ref={(el) => (combinedRef.current.player_image = el)}
                    name="player_image"
                    orientationSlug="landscape"
                    id={id}
                    idAttribute="audio-player-image"
                    error={formDataError?.player_image}
                  />

                  <MessageLabel text={labelDisplay?.[27]?.title} className={imagerequiredValidation?.audios === 1 ? "mandatorySimple" : ""} />
                  <MessageSubHeading text={labelDisplay?.[27]?.sub_title} />
                  <AdminImageUploadZone
                    onChange={handleFileChange}
                    selectedFile={tvImageFile}
                    uploadedImage={formData?.tv_image_url}
                    onDelete={handleClearSelectFile}
                    ref={(el) => (combinedRef.current.tv_image = el)}
                    name="tv_image"
                    orientationSlug="landscape"
                    idAttribute="audio-thumbnail-image"
                    error={formDataError?.tv_image}
                    id={id}
                  />
                </Wrapper >

                <Wrapper>
                  <MessageHeading text={labelDisplay?.[28]?.title} />
                  <MessageLabel text={labelDisplay?.[29]?.title} className="mandatorySimple" />
                  <MessageSubHeading text={labelDisplay?.[29]?.sub_title} />
                  <AdminCustomSelect name="access" id="audio-access" value={formData?.access} onChange={handleInput} ref={(el) => (combinedRef.current.access = el)} options={defaultOption?.accessOption?.filter(item => item?.role !== "ppv")?.map((item, index) => ({ name: item?.name, value: item?.role }))} error={formDataError?.access} defaultOptionName={"Choose an user access"} />

                  {formData?.access === "ppv" && <>
                    {globalPpvStatusActive?.PPV_Individual_Contents == 0 ?
                      (
                        <div className="mt-3">
                          <MessageLabel text={labelDisplay?.[42]?.title} />
                          <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                              <MessageSubHeading text={labelDisplay?.[42]?.sub_title} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                              <AdminSwitch id="audio-globa-ppv" name={'global_ppv'} checked={formData?.global_ppv == 1} onChange={handleInput} />
                            </div>
                          </div>
                          <AdminCustomInput id="audio-ppv-price" isReadonly={formData?.global_ppv == 1} type="text" name="ppv_price" value={formData?.ppv_price} onChange={handleInput} placeHolder={"ppv_price"} ref={(el) => (combinedRef.current.ppv_price = el)} error={formDataError?.ppv_price} />

                          <MessageLabel text={labelDisplay?.[44]?.title} />
                          {/* <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                              <MessageSubHeading text={labelDisplay?.[65]?.sub_title} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                              <AdminSwitch name={'global_ios_ppv'} checked={formData?.global_ios_ppv == 1} onChange={handleInput} />
                            </div>
                          </div> */}
                          <AdminCustomSelect id="audio-ios-ppv-price" name="ios_ppv_price" value={formData?.ios_ppv_price || 0} onChange={handleInput} ref={(el) => (combinedRef.current.ios_ppv_price = el)} options={defaultOption?.iosOption?.map((item, index) => ({ name: item?.plan_price, value: item?.id }))} error={formDataError?.ios_ppv_price} defaultOptionName={"Choose an ios price"} />
                        </div>
                      )
                      :
                      <div className="mt-3">
                        <AdminCustomButton id="audio-custom-ppv-button" saveMethod={() => handlePriceModal()} saveText="Customize PPV" className="d-block ms-auto mt-3" />
                      </div >
                    }
                  </>}
                  {/* {Array.isArray(defaultOption?.googleProductIdPPV) && defaultOption.googleProductIdPPV.length > 0 && (
                    <div className="mt-3">
                      <MessageLabel text="Google Product" />
                      <AdminCustomSelect
                        name="google_product_id_ppvs_id"
                        value={formData?.google_product_id_ppvs_id || ''}
                        onChange={(e) => {
                          const planId = e.target.value;
                          setFormData(prev => ({
                            ...prev,
                            google_product_id_ppvs_id: planId ? parseInt(planId) : null,
                          }));
                        }}
                        options={defaultOption.googleProductIdPPV.map(plan => ({
                          name: plan?.product_id || plan?.name || `Product ${plan?.id}`,
                          value: plan?.id,
                        }))}
                        defaultOptionName="Choose Google Purchase"
                      />
                    </div>
                  )} */}
                </Wrapper>
                <Wrapper>
                  <MessageHeading text={labelDisplay?.[30]?.title} />

                  <MessageLabel text={labelDisplay?.[31]?.title} />
                  <MessageSubHeading text={labelDisplay?.[31]?.sub_title} />
                  <AdminCustomInput id="audio-website-title" type="text" name="website_page_title" value={formData?.website_page_title} ref={(el) => (combinedRef.current.website_page_title = el)} onChange={handleInput} placeHolder={"Please enter website title"} error={formDataError?.website_page_title} />

                  <MessageLabel text={labelDisplay?.[32]?.title} className="" />
                  <MessageSubHeading text={labelDisplay?.[32]?.sub_title} />
                  <AdminCustomInput id="audio-website-url" type="text" name="website_URL" value={formData?.website_URL} onChange={handleInput} placeHolder={"Please enter website url"} ref={(el) => (combinedRef.current.website_URL = el)} error={formDataError?.website_URL} />

                  <MessageLabel text={labelDisplay?.[33]?.title} />
                  <MessageSubHeading text={labelDisplay?.[33]?.sub_title} />
                  <AdminCustomArea id="audio-meta-description" type="text" name="Meta_description" value={formData?.Meta_description || ""} onChange={handleInput} ref={(el) => (combinedRef.current.Meta_description = el)} placeHolder={"Please enter meta description"} rows={5} />
                </Wrapper>

                <Wrapper>
                  <MessageHeading text={labelDisplay?.[34]?.title} />
                  <div className="d-flex justify-content-between mb-2 ">
                    <div className="col-6 col-md-6 pe-2">
                      <MessageLabel text={labelDisplay?.[35]?.title} />
                    </div>
                    <div className="col-6 col-md-6 ps-2 text-end">
                      <AdminSwitch id="audio-featured" name={'featured'} checked={formData?.featured} onChange={handleInput} />
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mb-2 ">
                    <div className="col-6 col-md-6 pe-2">
                      <MessageLabel text={labelDisplay?.[36]?.title} />
                    </div>
                    <div className="col-6 col-md-6 ps-2 text-end">
                      <AdminSwitch id="audio-active" name={'active'} checked={formData?.active} onChange={handleInput} />
                    </div>
                  </div>
                  {onlyPermission?.includes(48) && (
                    <div className="d-flex justify-content-between mb-2 ">
                      <div className="col-6 col-md-6 pe-2">
                        <MessageLabel text={"Promote as Advertisement"} />
                      </div>
                      <div className="col-6 col-md-6 ps-2 text-end">
                        <AdminSwitch id="audio-is-ads" name={'is_ads'} checked={formData?.is_ads === 1} onChange={handleInput} />
                      </div>
                    </div>
                  )}
                </Wrapper>
                <Wrapper>
                  <MessageHeading text="Slider Setting" />
                  <div className="d-flex justify-content-between mb-2 ">
                    <div className="col-6 col-md-6 pe-2">
                      <MessageLabel text={labelDisplay?.[37]?.title} />
                    </div>
                    <div className="col-6 col-md-6 ps-2 text-end">
                      <AdminSwitch id="audio-banner" name={'banner'} checked={formData?.banner} onChange={handleInput} />
                    </div>
                  </div>
                  {formData?.banner === 1 && (
                    <>
                      <MessageLabel text="Slider Image" className={`${formData?.banner === 1 ? 'mandatorySimple' : ''}`} />
                      <MessageSubHeading text="Resolution 3840*1440 and Ratio 8:3" />
                      <AdminImageUploadZone
                        idAttribute={`audio-slider-image-${id}`}
                        onChange={handleFileChange}
                        selectedFile={sliderImageFile}
                        uploadedImage={formData?.Slider_Thumbnail}
                        onDelete={handleClearSelectFile}
                        ref={(el) => (combinedRef.current.slider_image = el)}
                        name="slider_image"
                        apiFieldName="slider_image"
                        error={formDataError?.slider_image}
                        id={id}
                      />
                    </>
                  )}
                </Wrapper>
              </RightWrapper>
              <AdminCustomButton id="audio-submit-button-down" saveMethod={handleStore} saveText={labelDisplay?.[40]?.title} className="ms-auto" />
            </FormContainer >
          </React.Fragment>
        }
      </div >
    </>
  );
}
const mapStateToProps = (state) => ({
  storageSetting: state.storageSetting.data,
  siteTheme: state.siteTheme.siteTheme,
  languageCodeData: state.languageCode.languageCodeData,
  onlyPermission: state.userPermission.onlyPermission
});

export default connect(mapStateToProps)(Editnewaudio)